import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles'

const DescriptionItem = ({ term, details }) => {
  return (
    <div className={styles.item}>
      <dt className={styles.term}>{term}:</dt>
      <dd className={styles.details}>{details}</dd>
    </div>
  )
}

DescriptionItem.propTypes = {
  term: PropTypes.string,
  details: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default DescriptionItem
